import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import BannerImage from "../../assets/anell360/AnnualFieldTrips/AnnualFieldTrips1.jpeg";

import { MdAdd, MdRemove, MdPublic, MdGroups, MdEmojiEvents, MdSchool, MdMap, MdFlightTakeoff, MdCelebration } from 'react-icons/md';
import { BsWhatsapp } from "react-icons/bs";
import { Link } from 'react-router-dom';

import { ParentTeacherGallery, SpeechAndPrizeGallery, ParentsWorkshopGallery, InternationalTripsGallery, GraduationGallery,AnnualFieldTripGallery, InternationalCommunityDayGallery } from '../../utils/galleryAssets';


const CollageGallery = ({ images }) => {
    if (!images || images?.length === 0) {
        return (
            <div className="h-[300px] bg-gray-50 rounded border-2 border-dashed border-gray-200 flex items-center justify-center mt-12">
                <span className="text-gray-400 font-medium italic">Photos appearing soon...</span>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-12">
            {images.map((img, index) => (
                <div 
                    key={index} 
                    className="h-48 md:h-64 rounded-xl overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500"
                >
                    <img src={img} className="w-full h-full object-cover" alt={`Gallery ${index + 1}`} />
                </div>
            ))}
        </div>
    );
};

const AccordionItem = ({ title, content, isOpen, onClick, images, icon: Icon }) => {
    return (
        <div className="border-b border-gray-100 last:border-0 hover:bg-gray-50/20 transition-colors">
            <button
                className={`w-full flex items-center justify-between py-4 px-3 lg:px-5 transition-all duration-500 ${isOpen ? 'bg-[#021d53] text-white shadow-2xl' : 'bg-white text-[#021d53]'}`}
                onClick={onClick}
            >
                <div className="flex items-center gap-8">
                    {Icon && <Icon className={` ${isOpen ? 'text-white' : 'text-[#ed3137]'}`} />}
                    <span className="md:text-lg font-black uppercase tracking-tight text-left leading-tight">{title}</span>
                </div>
                <div className={`p-2 rounded-full transition-transform duration-500 ${isOpen ? 'bg-white/20 rotate-180' : 'bg-gray-100'}`}>
                    {isOpen ? <MdRemove className="md:text-3xl" /> : <MdAdd className="md:text-3xl" />}
                </div>
            </button>
            <div 
                className={`overflow-hidden transition-all duration-700 ease-in-out ${isOpen ? 'max-h-[3000px] opacity-100' : 'max-h-0 opacity-0'}`}
            >
                <div className="p-8 lg:p-20 bg-white">
                    <p className=" text-gray-600 leading-relaxed text-center">
                        {content}
                    </p>
                    {images && images.length > 0 && (
                        <CollageGallery images={images} />
                    )}
                </div>
            </div>
        </div>
    );
};

const SignatureEvents = () => {
    const location = useLocation();
    const [openIndex, setOpenIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const events = [
        {
            title: "International Community Day",
            icon: MdPublic,
            content: "A vibrant celebration of cultures that promotes global awareness, unity, and appreciation of diversity. The Anell community comes together to showcase traditions, foods, and arts from around the world.",
            images: InternationalCommunityDayGallery
        },
        {
            title: "Parent–Teacher Conferences",
            icon: MdGroups,
            content: "Structured engagements that strengthen collaboration between home and school, ensuring every learner receives coordinated support. We value the partnership with parents in charting the best academic and personal path for each child.",
            images: ParentTeacherGallery
        },
        {
            title: "Speech and Prize-Giving Day",
            icon: MdEmojiEvents,
            content: "A celebration of achievement, character, and excellence across all areas of school life. We recognize the hard work of our learners and inspire them to reach even greater heights.",
            images: SpeechAndPrizeGallery
        },
        {
            title: "Parents’ Workshops",
            icon: MdSchool,
            content: "Interactive sessions designed to equip parents with practical tools and insights on child development, academic support, and positive parenting. These workshops create space for meaningful dialogue and reinforce the partnership between families and the school.",
            images: ParentsWorkshopGallery
        },
        {
            title: "Annual Field Trips",
            icon: MdMap,
            content: "Purposeful educational outings that extend learning beyond the classroom. Learners explore historical sites, institutions, and environments that deepen understanding, spark curiosity, and connect theory to real-life experiences.",
            images: AnnualFieldTripGallery
        },
        {
            title: "International Trips",
            icon: MdFlightTakeoff,
            content: "Carefully curated global experiences that broaden perspectives and expose learners to different cultures, systems, and innovations. These trips nurture independence, cultural intelligence, and confidence in navigating the wider world.",
            images: InternationalTripsGallery
        },
        {
            title: "Graduation Ceremonies",
            icon: MdCelebration,
            content: "A proud milestone marking growth, accomplishment, and readiness for the next stage of learning. It is a moment of reflection and celebration for both learners and their families.",
            images: GraduationGallery
        },
        {
            title:"End of year celebration",
            icon: MdCelebration,
            content: "The End of Year Celebrations at Anell School of Excellence is an annual event that brings together learners, parents, and staff to mark the successful completion of the academic year. It features exciting performances, exhibitions, and presentations by learners. The occasion also recognizes and rewards outstanding academic achievement and good conduct. It serves as a moment to reflect on the year’s progress and growth. Overall, it strengthens the bond between the school and its community.",
            
        }
    ];


    return (
        <div className="font-sans text-gray-900 bg-white min-h-screen">
            

            {/* Hero Section */}
            <div className="relative h-[65vh] lg:h-[80vh] w-full flex items-center justify-center overflow-hidden bg-[#221b2d]">
                <img 
                    src={BannerImage} 
                    alt="Signature Events Banner" 
                    className="absolute inset-0 h-full w-full object-cover opacity-50 scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#221b2d]/30 to-[#221b2d]/90"></div>
                <div className="relative z-10 text-center px-5 max-w-5xl">
                    <h1 className="text-5xl md:text-8xl font-black text-white mb-6 uppercase tracking-tighter drop-shadow-2xl">
                        Signature Events
                    </h1>
                    <div className="w-32 h-2 bg-[#ed3137] mx-auto mb-10"></div>
                    <p className="text-xl md:text-3xl text-blue-50 font-medium max-w-4xl mx-auto leading-relaxed drop-shadow-xl">
                        Meaningful engagements that bring our community together and breathe life into our values.
                    </p>
                </div>
            </div>

            {/* Introduction */}
            <section className="py-24 bg-white px-5 md:px-10 lg:px-20 text-center max-w-[1440px] mx-auto">
                <h2 className="text-3xl md:text-5xl font-black text-[#021d53] mb-10 leading-tight">Bridging Community & Excellence</h2>
                <div className="w-16 h-1 bg-[#ed3137] mx-auto mb-10"></div>
                <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-medium">
                    Anell School of Excellence hosts meaningful events that strengthen the bonds between learners, educators, and families.
                </p>
            </section>

            {/* Accordion Content Section */}
            <section className="pb-32 px-5 md:px-10 lg:px-20 max-w-[1440px] mx-auto">
                <div className="bg-white rounded shadow-[0_40px_150px_rgba(0,0,0,0.1)] overflow-hidden border border-gray-100">
                    {events.map((event, index) => (
                        <AccordionItem 
                            key={index}
                            title={event.title}
                            icon={event.icon}
                            content={event.content}
                            images={event.images}
                            isOpen={openIndex === index}
                            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                        />
                    ))}
                </div>
            </section>



            <Footer />
             
        </div>
    );
};

export default SignatureEvents;
